// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3NviC","title":"Header_title__3GlB1","side":"Header_side__3jQ3E"};